import { useCallback, useMemo, type ReactNode } from 'react';
import { useTheme } from '@/hooks/useTheme';

export type JpTheme = 'paper' | 'ink';

/** Compatibility wrapper: appearance is owned by the surrounding ThemeProvider. */
export function JpThemeProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}

/** Reader Paper/Ink controls share the app-wide preference and persistence. */
export function useJpTheme() {
  const { effectiveTheme, setTheme } = useTheme();
  const setJpTheme = useCallback((theme: JpTheme) => {
    setTheme(theme === 'paper' ? 'light' : 'dark');
  }, [setTheme]);

  return useMemo(() => ({
    theme: (effectiveTheme === 'light' ? 'paper' : 'ink') as JpTheme,
    setTheme: setJpTheme,
  }), [effectiveTheme, setJpTheme]);
}
